import { Component, OnInit } from '@angular/core';
import { HttpserviceService } from '../../service/http.service.service';
import { Router } from '@angular/router';
import { UtilsService } from '../../service/utils.service';
import { GlobalConfig } from '../../entities/global-config';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs/Subject';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ChartsModule } from 'ng2-charts';
import { Daterangepicker } from 'ng2-daterangepicker';
import { DaterangepickerConfig } from 'ng2-daterangepicker';
import { DatePipe } from '@angular/common';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';


declare var moment: any;

@Component({
  selector: 'app-phone-clicks',
  templateUrl: './phone-clicks.component.html',
  styleUrls: ['./phone-clicks.component.css']
})
export class PhoneClicksComponent implements OnInit {
  isList: Boolean = true;
  public mainInput = {
    start: moment().subtract(1, 'month'),
    end: moment().subtract(0, 'month')
  };

  public singlePicker = {
    minDate: moment().subtract(120, 'month'),
    maxDate: moment().add(12, 'month'),
    daterangepicker: true,
    showDropdowns: true,
    opens: 'left',
  };

  public singleDate: any;
  public eventLog = '';
  constructor(
    private servicesComponent: HttpserviceService,
    private router: Router,
    private utilsService: UtilsService,
    private config: GlobalConfig,
    private toastr: ToastsManager,
    private modalService: BsModalService,
    private daterangepickerOptions: DaterangepickerConfig
  ) {


    this.daterangepickerOptions.settings = {
      locale: { format: 'YYYY-MM-DD' },
      alwaysShowCalendars: false,
      ranges: {
        'Last Month': [moment().subtract(1, 'month'), moment()],
        'Last 3 Months': [moment().subtract(4, 'month'), moment()],
        'Last 6 Months': [moment().subtract(6, 'month'), moment()],
        'Last 12 Months': [moment().subtract(12, 'month'), moment()],
      }
    };
    this.singleDate = Date.now();
  }
  isAgent: Boolean = false;
  agentId: any = '';
  bsModalRef: BsModalRef;
  totalItems: any = Number;
  phoneLeads: any[] = [];
  phoneLeadsIds: any[] = [];
  agents: any[] = [];
  graphData: any = [];
  page: any = { pageNumber: 1, pageSize: 25, startDate: this.mainInput.start, endDate: this.mainInput.end, agentId: 0 };
  listDates: any = [];
  chartDates: any = [];
  chartDatesCount: any = [];
  phoneLeadsExport: any = [];
  lastMontDate: any = [];
  lineChartLegend: Boolean = true;
  lineChartType: String = 'line';
  lineChartData: any = [
    { data: this.chartDatesCount, label: 'Phone' },
  ];
  lineChartLabels: any = [];
  lineChartOptions: any = {
    responsive: true,
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          min: 0,
          max: 25
        }
      }]
    }
  };

  public lineChartColors: Array<any> = [
    { // grey
      backgroundColor: 'rgba(148,159,177,0.2)',
      borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];

  ngOnInit() {
    const roles = localStorage.getItem("role");
    this.setPermissions(roles);
    this.getPhoneLead();
    this.GetAgents();
  }

  setPermissions(roles) {
    const userId = Number(JSON.parse(localStorage.getItem("profile")).nameid);
    const data = this;
    if (roles != null) {
      const roleName = roles.split(",");
      roleName.forEach(function (value) {
        switch (value) {
          case "agents":
            data.agentId = userId;
            data.isAgent = true;
            break;

          default:
            break;
        }

      });
    }
  }

  getPhoneLead() {
    if (this.agentId > 0) {
      this.page.agentId = this.agentId;
    }
    this.servicesComponent.getPhoneLead(this.page)
      .then((response: any) => {
        if (response.success) {
          this.listDates = [];
          this.chartDates = [];
          this.phoneLeads = response.receiveObj.result.data;
          this.phoneLeads.forEach(a => {
            this.listDates.push(a.lineChartDate.split(' ')[0]);
          });
          this.getLineChartData();
          this.totalItems = response.receiveObj.result.total_rows;
          this.isList = this.phoneLeads.length > 0 ? true : false;
          if (!this.isList) {
            this.lineChartLabels = [];
          }
        } 
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  GetAgents() {
    this.servicesComponent.GetAgents()
      .then((response: any) => {
        if (response.success) {
          this.agents = response.receiveObj;
        } 
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  pageChanged(event: any): void {
    this.chartDatesCount = [];
    this.lineChartData = [{ data: this.chartDatesCount, label: 'phone' }];
    this.lineChartLabels = [];
    this.listDates = [];
    this.chartDates = [];
    this.page.pageNumber = event.page;
    this.page.pageSize = event.itemsPerPage;
    this.getPhoneLead();
  }

  searchPhoneLead() {
    this.chartDatesCount = [];
    this.lineChartData = [{ data: this.chartDatesCount, label: 'phone' }];
    this.lineChartLabels = [];
    this.listDates = [];
    this.chartDates = [];
    this.page.pageNumber = 1;
    this.getPhoneLead();
  }

  private selectedDate(value: any, dateInput: any) {
    dateInput.start = value.start;
    dateInput.end = value.end;
    var datePipe = new DatePipe('en-US');
    this.page.startDate = datePipe.transform(dateInput.start, 'yyyy-MM-dd');
    this.page.endDate = datePipe.transform(dateInput.end, 'yyyy-MM-dd');
    this.searchPhoneLead();
  }

  private singleSelect(value: any) {
    this.singleDate = value.start;
  }

  private applyDate(value: any, dateInput: any) {
    dateInput.start = value.start;
    dateInput.end = value.end;
  }

  public calendarEventsHandler(e: any) {
    this.eventLog += '\nEvent Fired: ' + e.event.type;
  }

  getLineChartData() {
    var dates = this.listDates;
    var chartCount = [];
    var chartLabel = [];
    var inBwDates = this.getDates(this.page.startDate, this.page.endDate);
    var dateObj = {};

    inBwDates.forEach(elm => {
      dateObj[elm] = 0;
    });

    dates.forEach(elm => {
      var val = dateObj[elm];
      val = (val != undefined) ? val + 1 : 0;
      dateObj[elm] = val;
    });

    for (var key in dateObj) {
      chartCount.push(dateObj[key]);
      chartLabel.push(key);
    }

    this.chartDatesCount = chartCount;
    this.lineChartData[0].data = chartCount;
    this.lineChartLabels = chartLabel;
  }

  clearLeads() {
    this.mainInput.start = "";
    this.mainInput.end = "";

    var mainInput1 = {
      start: moment().subtract(1, 'month'),
      end: moment().subtract(0, 'month')
    };

    this.mainInput.start = mainInput1.start.format("DD-MM-YYYY");
    this.mainInput.end = mainInput1.end.format("DD-MM-YYY");

    this.page.referenceNumber = '';
    this.page.areaName = '';
    this.page.subAreaName = '';
    this.page.startDate = mainInput1.start.format("YYYY-MM-DD");
    this.page.endDate = mainInput1.end.format("YYYY-MM-DD");
    this.page.agentId = 0;
    this.searchPhoneLead();
  }

  exportClickLead() {
    if (this.agentId > 0) {
      this.page.agentId = this.agentId;
    }
    this.servicesComponent.exportPhoneLead(this.page)
      .then((response: any) => {
        if (response.success) {
          this.phoneLeadsExport = response.receiveObj.result;
          if (this.phoneLeadsExport.length > 0) {
            this.exportClickData();
          }
          else {
            this.toastr.info('No Click Lead Data For Export.', 'Info!');

          }

        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  exportClickData() {
    var head = ['Ref No', 'Location', 'Sub Location', 'Price', 'Date', 'IPAddress']
    new Angular2Csv(this.phoneLeadsExport, "clickLeads", { headers: (head) });

  }

  keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.searchPhoneLead();
    }
  }

  getDates(start, end) {
    var datesArray = [];

    var newStart = new Date(start);
    var newEnd = new Date(end);
    start = newStart;
    end = newEnd;
    var startDate = new Date(start);
    while (startDate <= end) {
      var m = (startDate.getMonth() + 1);
      var d = startDate.getDate();
      var da = d > 9 ? d : '0' + d.toString();
      var mo = m > 9 ? m : '0' + m.toString();
      var newDate = da + '-' + mo + '-' + startDate.getFullYear();
      datesArray.push(newDate);
      startDate.setDate(startDate.getDate() + 1);
    }
    return datesArray;
  }
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/manageLead/phone-clicks/phone-clicks.component.ts